const MESSENGER_DICT = {
  0: 'Aitu',
  1: 'Viber',
  2: 'WhatsApp',
  3: 'Telegram',
  4: 'Yandex',
  5: 'Max',
  6: 'Bitrix',
  7: 'P7',
  8: 'Aitu',
};

export const messengerName = (val) => MESSENGER_DICT[val];

const directionNameDict = {
  31: 'incoming',
  32: 'outgoing',
};

export const directionName = (val) => directionNameDict[val];
